export const DELIMITER_ANNOTATIONS = String.fromCharCode(20);
export const DELIMITER_DURATION = String.fromCharCode(21);
export const DELIMITER_TAL_END = String.fromCharCode(0);
export const DELIMITER_TAG_CHANNELS = ':';
export const DELIMITER_CHANNELS = ',';

export function createTimeArr(onset, duration) {
    const hasDuration = !!duration;

    return hasDuration ? `${onset}${DELIMITER_DURATION}${duration}` : onset;
}

export function createAnnotationLabelsArr(labels, tag) {
    // If present, the tag must become the first label in the TAL
    // The empty strings will ensure the delimiter is inserted at the ends by join
    const sequence = tag ? ['', tag, ...labels, ''] : ['', ...labels, ''];

    return sequence.join(DELIMITER_ANNOTATIONS);
}

/**
 * @param {Annotation}
 * @return {string} String encoded with TAL delimiters.
 */
export function createTAL(annotation) {
    // Negative sign will be included when converted to string. Plus sign does not.
    const sign = annotation.onset >= 0 ? '+' : '';
    const onsetString = `${sign}${annotation.onset}`;
    const timeArr = createTimeArr(onsetString, annotation.duration);
    const annotationLabelArr = createAnnotationLabelsArr(annotation.labels, annotation.tag);

    return `${timeArr}${annotationLabelArr}${DELIMITER_TAL_END}`;
}
